<template>
  <div id="itemBlog">
    <div class=" container">
      <br />
      <br />
      <div class="column is-multilines" v-if="isLoading">
        <div class="column is-full">
          <b-skeleton height="180px"></b-skeleton>
          <b-skeleton width="20%" :animated="true"></b-skeleton>
          <b-skeleton width="40%" :animated="true"></b-skeleton>
          <b-skeleton width="80%" :animated="true"></b-skeleton>
          <b-skeleton width="80%" :animated="true"></b-skeleton>
          <b-skeleton width="100%" :animated="true"></b-skeleton>
          <b-skeleton width="100%" :animated="true"></b-skeleton>
        </div>
        <div class="column is-full">
          <b-skeleton height="300px"></b-skeleton>
        </div>
      </div>

      <div class="columns is-multiline" v-if="!isLoading && post != {}">
        <div class="column is-full">
          <section class="news-section">
            <h1 class="is-size-4">{{ post.content[currentLocale].title }}</h1>
            <time>{{ post.create }}</time>
            <br />
            <br />
            <component v-bind:is="loadComponent" />
          </section>
          <br />
          <br />
        </div>
        <hr />
        <div class="column is-full">
          <br />
          <div class="columns is-multiline">
            <div
              class="column is-4"
              v-for="(post, index) in allpost"
              :key="index"
              @click="showPost()"
            >
              <post-card v-bind:post="post" />
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import i18n from "@/i18n.js";
import PostCard from "@/components/PostCard.vue";
export default {
  name: "itemBlog",
  data() {
    return {
      post: {},
      allpost: [],
      locale: i18n.locale,
      rute: this.$router.currentRoute.params.name,
      component: null,
      isLoading: true,
    };
  },
  mounted() {
    this.loadPost();
  },
  components: {
    PostCard,
  },
  methods: {
    showPost() {
      window.location.reload();
    },
    async loadPost() {
      this.isLoading = true;
      this.post = {};
      this.allpost = [];
      await import("@/assets/post.json")
        .then((res) => {
          // console.log(res.data)
          // let posts = res.data.filter((e) => e.path != this.rute);
          this.allpost = res.data;
        })
        .then(() => {
          this.post = this.allpost.filter((e) => {
            return e.path == this.rute;
          })[0];
          this.allpost = this.allpost
            .filter((e) => e.status)
            .filter((e) => e.path != this.rute);
          this.isLoading = false;
        })
        .catch((err) => {
          console.error(err);
        });
    },
  },
  computed: {
    loadComponent() {
      return () => import(`./news/${this.rute}`);
    },
    currentLocale() {
      return i18n.locale;
    },
    icon() {
      let value = "flag";
      switch (this.post.type) {
        case "evento":
          value = "calendar-day";
          break;
        case "lanzamiento":
          value = "rocket";
          break;
        case "novedad":
          value = "tag";
          break;
        case "noticia":
          value = "newspaper";
          break;
      }
      return value;
    },
    color() {
      let value = "is-info";
      switch (this.post.type) {
        case "evento":
          value = "has-background-success";
          break;
        case "lanzamiento":
          value = "has-background-link";
          break;
        case "novedad":
          value = "has-background-warning";
          break;
        case "noticia":
          value = "has-background-grey";
          break;
      }
      return value;
    },
  },
};
</script>
